exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link{color:#3598dc;border-bottom:1px solid #3598dc;cursor:pointer}.link:active,.link:focus,.link:hover{font-weight:600;text-decoration:none;color:#0f77ae;border-bottom:1px dashed #0f77ae}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bf41036","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/user/lastAccess/lastAccess.vue
// module id = 1029
// module chunks = 0